export const INDUSTRIES = [
  {
    id: "oil-gas",
    name: "Oil & Gas",
    short: "Upstream, midstream & downstream",
    image: "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    bullets: [
      "CRA pipe overlay for sour service",
      "Subsea flowline cladding",
      "Refinery process equipment"
    ]
  },
  {
    id: "petrochemical",
    name: "Petrochemical",
    short: "Corrosion-resistant overlays",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Reactor & vessel internals",
      "Heat exchanger tubesheets",
      "Header & manifold overlay"
    ]
  },
  {
    id: "power",
    name: "Power Generation",
    short: "Conventional & nuclear",
    image: "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Boiler tube panel overlay",
      "Turbine component cladding",
      "Critical pressure parts"
    ]
  },
  {
    id: "waste-to-energy",
    name: "Waste to Energy",
    short: "Boiler tube protection",
    image: "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Inconel overlay on boiler tubes",
      "Panel-width cladding",
      "Corrosion & erosion protection"
    ]
  },
  {
    id: "valve",
    name: "Valve Manufacturing",
    short: "Seat & body cladding",
    image: "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Valve seat overlay",
      "Body internal cladding",
      "Stellite & Inconel overlays"
    ]
  },
  {
    id: "cra-pipe",
    name: "CRA Pipe Manufacturing",
    short: "High-volume overlay",
    image: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Twin & Quad-head production rigs",
      "Inline DPT inspection",
      "ID & OD overlay solutions"
    ]
  },
  {
    id: "nuclear",
    name: "Nuclear",
    short: "Code-grade welding automation",
    image: "https://images.unsplash.com/photo-1532634726-8b9fb99825c8?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Code-quality automation",
      "Documented traceability",
      "High-purity cladding"
    ]
  },
  {
    id: "epc",
    name: "EPC Contractors",
    short: "Project-grade execution",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1600&q=80",
    bullets: [
      "Spool & module cladding",
      "Site / shop solutions",
      "Project delivery support"
    ]
  },
  {
    id: "heavy",
    name: "Heavy Engineering",
    short: "Custom automation",
    image: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    bullets: [
      "Bespoke automation cells",
      "Robotic integration",
      "Large workpiece handling"
    ]
  }
];

export const WHY_PILLARS = [
  { n: "01", t: "15+ Years Industry Experience", d: "Decades of hands-on engineering across welding, automation and overlay systems." },
  { n: "02", t: "In-House Engineering Team", d: "Mechanical, electrical, PLC and HMI engineering — all under one roof." },
  { n: "03", t: "Manufacturing Facility", d: "Dedicated fabrication, assembly and integration capability." },
  { n: "04", t: "R&D Driven Innovation", d: "Continuous development of overlay processes, Hot Wire TIG and automation logic." },
  { n: "05", t: "Global Service Support", d: "Commissioning, training and remote diagnostics worldwide." },
  { n: "06", t: "Advanced Automation Expertise", d: "Servo control, PLC integration and Industry 4.0 ready architectures." }
];

export const TECHNOLOGY = [
  { code: "PWR", t: "EWM Germany Power Sources", d: "Industry-leading synergic & TIG inverter platforms." },
  { code: "PLC", t: "Omron PLC Systems", d: "Deterministic motion & process control." },
  { code: "SRV", t: "Servo Automation", d: "Precision multi-axis servo positioning." },
  { code: "HWT", t: "Hot Wire TIG Technology", d: "Higher deposition with metallurgical purity." },
  { code: "RDX", t: "Remote Diagnostics", d: "Predictive maintenance & live process telemetry." },
  { code: "HMI", t: "Advanced HMI Systems", d: "Recipe-driven, operator-first interfaces." }
];

export const PROCESS_STEPS = [
  { n: "01", t: "Design Engineering", d: "Concept, CAD & engineering simulation." },
  { n: "02", t: "Fabrication", d: "Precision fabrication of structural & motion sub-assemblies." },
  { n: "03", t: "Assembly", d: "Mechanical + electrical + control integration." },
  { n: "04", t: "Testing", d: "Factory acceptance testing with weld trials." },
  { n: "05", t: "Commissioning", d: "On-site installation, calibration & training." },
  { n: "06", t: "After-Sales Support", d: "Service contracts, spares & remote diagnostics." }
];

export const PROJECTS = [
  {
    title: "CRA Pipe Cladding Line",
    client: "Tier-1 CRA Pipe Manufacturer",
    location: "Middle East",
    image: "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/2o2oz355_PIPE%20RIG.png",
    outcome: "Quad-head pipe cladding rig delivered 3.8x throughput vs. previous setup."
  },
  {
    title: "Vertical Clad Station Install",
    client: "Energy Major",
    location: "India",
    image: "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/yoyvceri_System%20Image-VCS-1.jpg",
    outcome: "VCS commissioned with <±0.5 mm overlay deviation across all parts."
  },
  {
    title: "Boiler Tube Panel Overlay",
    client: "Waste-to-Energy Plant",
    location: "Europe",
    image: "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/b92pxada_Boiler%20Wall%20System%20render%20Image.png",
    outcome: "Inconel overlay on 2.8 m panels with consistent low-dilution metallurgy."
  }
];

export const COMPANY = {
  name: "Weldmatix Fusion Pvt. Ltd.",
  email_sales: "sales@clangrp.com",
  email_info: "sales@clangrp.com",
  website: "www.weldmatixco.com",
  location: "Navi Mumbai, Maharashtra, India",
  phone: "+91 80801 41040",
  whatsapp: "+91 80801 41040",
  whatsapp_link: "https://wa.me/918080141040",
  brochure_url: "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/prynzciw_Weldmatix-Fusion-Product-Catalogue-2026%20%283%29%20%281%29.pdf",
  clan_logo: "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/r2odujeh_Clan%20Group.png",
  clan_link: "https://www.clangrp.com",
  tagline: "Engineering Excellence. Global Reach."
};
